export const EntityTypes = {
  AgenticProcess: 'agentic_process',
  SubAgent: 'subagent',
  Agent: 'agent',
  Annotation: 'annotation',
  ApiKey: 'api_key',
  Artifact: 'artifact',
  Deployment: 'deployment',
  Bookmark: 'bookmark',
  Comment: 'comment',
  ComputeNode: 'compute_node',
  Flow: 'flow',
  Func: 'func',
  GraphContext: 'graph_context',
  Job: 'job',
  JobExecution: 'job_execution',
  KnowledgeBase: 'knowledge_base',
  Mention: 'mention',
  Page: 'page',
  Plugin: 'plugin',
  PluginManifest: 'plugin_manifest',
  ProcessResult: 'process_result',
  Project: 'project',
  Question: 'question',
  Shell: 'shell',
  Skill: 'skill',
  Task: 'task',
  Trigger: 'trigger',
  User: 'user',
  Visitor: 'visitor',
  WebDomain: 'web_domain',
  Wiki: 'wiki',
  WikiEntry: 'wiki_entry',
  Workflow: 'workflow',
  Workspace: 'workspace',
} as const;

export type EntityType = (typeof EntityTypes)[keyof typeof EntityTypes];
